import React, { Component } from 'react';
import SBottomBar from 'shared/components/BottomBar';
import { TAG } from 'shared/constants';
import Screens from 'shared/screens';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import audio from 'shared/utils/audio';
import { ThemeContext } from 'styled-components';
import { pwaStyleAdapter } from '../../utils/mobileSupported';
import LazyImage from '../LazyImage/LazyImage';
import TimeRemainingText from '../TimeRemainingText';
import EventsIcon from './components/EventsIcon';
import MissionsIcon from './components/MissionsIcon';
import NotificationBadge from '../NotificationBadge/NotificationBadge';
import { BOTTOM_BAR_CONTENT_CONTAINER_ID } from './constants';
import Divider from './components/Divider';
import AppBackgroundType from 'shared/utils/AppBackgroundType';

const MAX_CHEST_UPDATE_RETRIES = 15;
const safariPreventStyles = {
  WebkitUserSelect: 'none',
  MozUserSelect: 'none',
  msUserSelect: 'none',
  userSelect: 'none',
  WebkitTouchCallout: 'none',
  WebkitTapHighlightColor: 'transparent',
  touchAction: 'manipulation',
};

const imagePreventStyles = {
  ...safariPreventStyles,
  WebkitUserDrag: 'none',
  KhtmlUserDrag: 'none',
  MozUserDrag: 'none',
  OUserDrag: 'none',
  userDrag: 'none',
  pointerEvents: 'auto',
};

export default class BottomBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: true,
      showLeftTooltip: false,
      showRightTooltip: false,
      playChestAnimation: false,
      animationWidth: 0,
      animationHeight: window.innerHeight,
    };
    this.chestRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize);
    this.getElements = setInterval(() => {
      if (!this.currencyDisplay) {
        this.currencyDisplay = document.getElementById('CurrencyDisplay');
      }
      if (!this.animation) {
        this.animation = document.getElementById('animationContainer');
      }

      if (this.animation && this.currencyDisplay && this.state.animationWidth === 0) {
        const { animationWidth, animationHeight } = this.getAnimationDimensions();
        this.setState({ animationWidth, animationHeight });
        clearInterval(this.getElements);
      }
    }, 100);
  }

  componentDidUpdate(prevProps, prevState) {
    this.updateDimensions(prevState);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
    clearTimeout(this.updateTimeout);
    clearInterval(this.getElements);
  }

  updateDimensions(prevState, retries = 0) {
    if (this.animation && this.currencyDisplay) {
      const { animationWidth, animationHeight } = this.getAnimationDimensions();
      if ((animationWidth <= 0 || animationHeight <= 0) && retries <= MAX_CHEST_UPDATE_RETRIES) {
        this.updateTimeout = setTimeout(() => this.updateDimensions(prevState, retries + 1), 50);
      } else {
        if (
          (animationWidth !== prevState.animationWidth || animationHeight !== prevState.animationHeight) &&
          (this.state.animationWidth <= 0 || this.state.animationHeight <= 0)
        ) {
          this.setState({ animationWidth, animationHeight });
        }
      }
    }
  }

  getAnimationDimensions = () => {
    const animationWidth = pwaStyleAdapter(
      window.innerWidth -
        (window.innerWidth -
          (this.animation.getBoundingClientRect().x + this.animation.getBoundingClientRect().width)) -
        this.currencyDisplay.getBoundingClientRect().x -
        30
    );
    const animationHeight = pwaStyleAdapter(window.innerHeight);

    return { animationWidth, animationHeight };
  };

  resize = () => {
    this.currencyDisplay = document.getElementById('CurrencyDisplay');
    this.animation = document.getElementById('animationContainer');
    if (this.animation && this.currencyDisplay) {
      const { animationWidth, animationHeight } = this.getAnimationDimensions();
      this.setState({ animationWidth, animationHeight });
    }
  };

  _sharedWillUpdate = (nextProps, nextState) => {
    if (this.state.visible !== nextState.visible) this.setState({ visible: nextState.visible });
  };

  handleSafariClick = callback => event => {
    event.preventDefault();
    event.stopPropagation();

    if (window.getSelection) {
      window.getSelection().removeAllRanges();
    }

    if (callback && this.state.visible) {
      callback();
    }
  };

  render() {
    const themeContext = this.context;

    return (
      <SBottomBar
        navigation={this.props.navigation}
        sharedWillUpdate={this._sharedWillUpdate}
        render={args => {
          const {
            showModal,
            openChest,
            TIME_LEFT,
            timedBonusHandle,
            isVIPRoom,
            isVipRoomUnlocked,
            videoAds,
            appBackground,
            sidebarState,
            setSidebarState,
            claimingBonus,
            unreadMessageCount,
            unreadOfferCount,
            showEventsButton,
            rewardCenterMiddleware,
            isBlockedForMissionsTutorial,
            handleOnClickVipAccess,
          } = args;

          const showBadge = unreadMessageCount > 0;
          const showRewardCenterBadge = unreadOfferCount > 0;
          const showPlusOneHundred = unreadMessageCount > 99;

          return (
            <div
              id={BOTTOM_BAR_CONTENT_CONTAINER_ID}
              className={'navBar bottom' + (this.state.visible === false ? ' hide' : ' show')}
              style={{
                ...pwaStyleAdapter(themeContext.BottomBar.BottomBarBackground),
                ...safariPreventStyles,
                pointerEvents: isBlockedForMissionsTutorial ? 'none' : 'auto',
                ...(isBlockedForMissionsTutorial && { zIndex: 210 }),
              }}
            >
              <div
                style={{
                  ...pwaStyleAdapter(themeContext.BottomBar.BottomBarContainer),
                  ...safariPreventStyles,
                }}
              >
                <div className="flexBarSection" style={{ flex: 2, ...safariPreventStyles }}>
                  {!showEventsButton && (
                    <div
                      style={{
                        ...pwaStyleAdapter(themeContext.BottomBar.BarItem),
                        ...safariPreventStyles,
                      }}
                    />
                  )}

                  <div
                    style={{
                      ...pwaStyleAdapter(themeContext.BottomBar.BarItem),
                      ...safariPreventStyles,
                    }}
                    onClick={this.handleSafariClick(
                      videoAds && (videoAds.timeUntilReset === 0 || videoAds.remaining > 0)
                        ? () => showModal(Screens.VideoAds)
                        : () => showModal(Screens.WatchAndEarnInfo)
                    )}
                    onTouchStart={e => e.preventDefault()}
                  >
                    <LazyImage
                      tag={TAG.IMG}
                      alt="Bottom Bar"
                      src={assetSource(ASSET_KEY.WATCH)}
                      draggable="false"
                      style={{
                        ...pwaStyleAdapter(themeContext.BottomBar.WatchAndEarnIcon),
                        ...imagePreventStyles,
                      }}
                    />
                    {videoAds && videoAds.remaining > 0 && (
                      <NotificationBadge
                        textStyle={pwaStyleAdapter(themeContext.BottomBar.NotificationText)}
                        count={videoAds.remaining}
                        theme={pwaStyleAdapter(themeContext.BottomBar.NotificationWatchAndEarn)}
                      />
                    )}
                  </div>

                  {showEventsButton && <EventsIcon navigation={this.props.navigation} />}
                  <Divider />

                  <div
                    style={{
                      ...pwaStyleAdapter(themeContext.BottomBar.BarItem),
                      ...safariPreventStyles,
                    }}
                    onClick={this.handleSafariClick(() => showModal(Screens.Social))}
                    onTouchStart={e => e.preventDefault()}
                  >
                    <LazyImage
                      tag={TAG.IMG}
                      alt="Bottom Bar"
                      src={assetSource(ASSET_KEY.MAIL)}
                      draggable="false"
                      style={{
                        ...pwaStyleAdapter(themeContext.BottomBar.MailIcon),
                        ...imagePreventStyles,
                      }}
                    />
                    {showBadge && (
                      <NotificationBadge
                        textStyle={pwaStyleAdapter(themeContext.BottomBar.NotificationText)}
                        count={showPlusOneHundred ? '99' : unreadMessageCount}
                        theme={pwaStyleAdapter(themeContext.BottomBar.NotificationMail)}
                      />
                    )}
                  </div>
                </div>

                <div
                  className="flexBarSection"
                  style={{
                    height: '100%',
                    flex: 1,
                    ...safariPreventStyles,
                  }}
                >
                  <Divider />
                  <div
                    style={{
                      ...pwaStyleAdapter(themeContext.BottomBar.BarItem),
                      ...safariPreventStyles,
                    }}
                    onClick={this.handleSafariClick(rewardCenterMiddleware)}
                    onTouchStart={e => e.preventDefault()}
                  >
                    <LazyImage
                      tag={TAG.IMG}
                      alt="Bottom Bar"
                      src={assetSource(ASSET_KEY.REWARDS)}
                      draggable="false"
                      style={{
                        ...pwaStyleAdapter(themeContext.BottomBar.RewardCenterIcon),
                        ...imagePreventStyles,
                      }}
                    />
                    {showRewardCenterBadge && (
                      <div
                        style={{
                          ...pwaStyleAdapter(themeContext.BottomBar.RewardCenterBadge),
                          ...safariPreventStyles,
                        }}
                      >
                        {unreadOfferCount}
                      </div>
                    )}
                  </div>
                  <Divider />
                </div>

                <div className="flexBarSection" style={{ flex: 2, ...safariPreventStyles }}>
                  <div
                    style={{
                      ...themeContext.BottomBar.VIPWrapper,
                      ...safariPreventStyles,
                    }}
                    onClick={this.handleSafariClick(() => {
                      audio.onClick();
                      setSidebarState(!sidebarState);
                      handleOnClickVipAccess();
                    })}
                    onTouchStart={e => e.preventDefault()}
                  >
                    {!isVIPRoom && (
                      <div className="VIPIconContainer" style={safariPreventStyles}>
                        {!isVipRoomUnlocked && (
                          <LazyImage
                            tag={TAG.IMG}
                            alt="Bottom Bar VIP"
                            src={assetSource(ASSET_KEY.VIP_ENTRY_LOCKED)}
                            draggable="false"
                            style={{
                              ...pwaStyleAdapter(themeContext.BottomBar.VIPIcon),
                              ...imagePreventStyles,
                            }}
                          />
                        )}
                        {appBackground !== AppBackgroundType.VIP_GAMES && isVipRoomUnlocked && (
                          <LazyImage
                            tag={TAG.IMG}
                            alt="Bottom Bar VIP"
                            src={assetSource(ASSET_KEY.VIP_ROOM)}
                            draggable="false"
                            style={{
                              ...pwaStyleAdapter(themeContext.BottomBar.VIPIcon),
                              ...imagePreventStyles,
                            }}
                          />
                        )}
                      </div>
                    )}
                    {(isVIPRoom || appBackground === AppBackgroundType.VIP_GAMES) && (
                      <div className="SlotIconContainer" style={safariPreventStyles}>
                        <LazyImage
                          tag={TAG.IMG}
                          className="SlotIcon"
                          alt="Bottom Bar Slot"
                          src={assetSource(ASSET_KEY.SLOTS)}
                          draggable="false"
                          style={{
                            ...pwaStyleAdapter(themeContext.BottomBar.SlotsIcon),
                            ...imagePreventStyles,
                          }}
                        />
                      </div>
                    )}
                  </div>

                  <Divider />

                  <div
                    ref={this.chestRef}
                    style={{
                      ...pwaStyleAdapter(themeContext.BottomBar.BarChestItem),
                      ...safariPreventStyles,
                    }}
                    onClick={this.handleSafariClick(
                      openChest
                        ? () => {
                            timedBonusHandle();
                            this.props.startAnimationCallback && this.props.startAnimationCallback();
                            this.setState({ playChestAnimation: true });
                          }
                        : () => {}
                    )}
                    onTouchStart={e => e.preventDefault()}
                  >
                    {!openChest && !claimingBonus ? (
                      <LazyImage
                        tag={TAG.IMG}
                        style={{
                          ...pwaStyleAdapter(themeContext.BottomBar.ChestClosedBarIcon),
                          ...imagePreventStyles,
                        }}
                        alt="Bar Item Icon"
                        className={!claimingBonus ? 'TimedChest' : 'TimedChest RotateChest'}
                        src={assetSource(ASSET_KEY.TIMED_BONUS_CHEST_CLOSE)}
                        draggable="false"
                      />
                    ) : (
                      <LazyImage
                        tag={TAG.IMG}
                        style={{
                          ...pwaStyleAdapter(themeContext.BottomBar.ChestOpenBarIcon),
                          ...imagePreventStyles,
                        }}
                        alt="Bar Item Icon"
                        className={'TimedChest'}
                        src={assetSource(ASSET_KEY.TIMED_BONUS_CHEST_OPEN)}
                        draggable="false"
                      />
                    )}
                    <div
                      style={{
                        ...themeContext.BottomBar.TimerWrapper,
                        ...safariPreventStyles,
                      }}
                    >
                      <img
                        style={{
                          ...themeContext.BottomBar.TimerBackground,
                          ...imagePreventStyles,
                          opacity: !TIME_LEFT || TIME_LEFT === 0 ? 1 : 0,
                        }}
                        alt="Timed Bonus Timer"
                        src={assetSource(ASSET_KEY.TIMER_COLLECT_BACKING)}
                        draggable="false"
                      />
                      <img
                        style={{
                          ...themeContext.BottomBar.TimerBackground,
                          ...imagePreventStyles,
                          opacity: TIME_LEFT > 0 ? 1 : 0,
                        }}
                        alt="Timed Bonus Timer"
                        src={assetSource(ASSET_KEY.TIMER_WAITING_BACKING)}
                        draggable="false"
                      />
                      {TIME_LEFT > 0 && (
                        <TimeRemainingText
                          style={{
                            ...themeContext.BottomBar.TimerLabel,
                            ...safariPreventStyles,
                          }}
                          until={TIME_LEFT}
                          hideOnFinish
                        />
                      )}
                    </div>
                  </div>

                  <MissionsIcon {...this.props} />
                </div>
              </div>
            </div>
          );
        }}
      />
    );
  }
}

BottomBar.contextType = ThemeContext;

